/**
 * True when the SPA runs inside the GETFOOD Pro desktop app.
 *
 * The `window.electron` check covers the legacy Electron shell, kept only until every terminal has
 * migrated to the Tauri desktop app. Remove it afterwards.
 */
const isDesktopApp = () => {
  if (typeof window === 'undefined') return false

  if (typeof window.desktopApp === 'object' && window.desktopApp?.isDesktopApp) {
    return true
  }

  // Legacy Electron shell
  if (typeof window.electron === 'object' && window.electron !== null) {
    return true
  }

  return false
}

export default isDesktopApp
